import api from "@/lib/api";

const CHUNK = 4 * 1024 * 1024;

export async function uploadMedia(file, onProgress) {
  const uploadId = crypto.randomUUID().replace(/-/g, "");
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  let res;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", i);
    fd.append("total", total);
    fd.append("content_type", file.type);
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    const { data } = await api.post("/exercises/upload/chunk", fd, {
      onUploadProgress: (e) => onProgress(Math.round(((i + (e.loaded / (e.total || 1))) / total) * 100)),
    });
    res = data;
  }
  return res;
}

export function detectAspect(file) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const done = (w, h) => { URL.revokeObjectURL(url); resolve(w && h ? (h > w ? "9:16" : "16:9") : null); };
    if (file.type.startsWith("video/")) {
      const v = document.createElement("video");
      v.preload = "metadata";
      v.onloadedmetadata = () => done(v.videoWidth, v.videoHeight);
      v.onerror = () => done(0, 0);
      v.src = url;
    } else {
      const img = new Image();
      img.onload = () => done(img.naturalWidth, img.naturalHeight);
      img.onerror = () => done(0, 0);
      img.src = url;
    }
  });
}

const YT = /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([\w-]{11})/;
const IG = /instagram\.com\/(reels?|p|tv)\/([\w-]+)/;

export function previewFromLink(kind, url, aspect) {
  if (kind === "youtube") {
    const m = url.match(YT);
    return m && { kind, embed_url: `https://www.youtube.com/embed/${m[1]}`, aspect };
  }
  if (kind === "instagram") {
    const m = url.match(IG);
    return m && { kind, embed_url: `https://www.instagram.com/${m[1] === "p" ? "p" : "reel"}/${m[2]}/embed/`, aspect };
  }
  return url.startsWith("https://") ? { kind: "gif", url, aspect } : null;
}

export const discardUpload = (path) => api.post("/exercises/upload/discard", null, { params: { path } }).catch(() => {});

export const defaultAspect = (kind, url) =>
  kind === "instagram" || (kind === "youtube" && url.includes("/shorts/")) ? "9:16" : "16:9";
